<template>
  <v-container fluid fill-height>
    <v-layout column>
      <v-flex>
        <v-layout align-center justify-center column fill-height>
          <div class="text-xs-center">
            <v-progress-circular
              :size="50"
              :indeterminate="true"
              color="resBlue">
            </v-progress-circular>
          </div>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    name: 'ResLoading',
    data () {
      return {
      }
    }
  }
</script>

<style>
</style>
